(function() {
	/**
   * Render Homepage (vereinfachte Version, nur Wetter) — hardened
   * - Lädt pageContent
   * - Lädt static municipalities + sky_conditions
   * - Lädt GENAU EINE Prognose (erste verfügbare TL)
   */
	WebBaseAprovLV.renderHome = function(props) {
		var Utils = (WebBaseAprovLV && WebBaseAprovLV.Utils) || {};
		var lang = WebBaseAprovLV.lang;
		var dfdRoot = $.Deferred();
		var t0 = (window.performance && performance.now && performance.now()) || Date.now();
		if (!Utils || !Utils.fetchAsync || !Utils.getKKData) {
			console.error('[home] Utils missing');
			return dfdRoot.reject(new Error('Utils missing')).promise();
		}
		var fetchAsync = Utils.fetchAsync({ dataType: 'json', cache: true, timeout: 12000 });
		var fetchFresh = Utils.fetchAsync({ dataType: 'json', cache: false, timeout: 12000 });
		function safeJSON(call, defaultVal, label) {
			var dfd = $.Deferred();
			call
			.done(function(resp) { dfd.resolve(resp); })
			.fail(function(_jq, textStatus, err) {
				console.warn('[home] failed:', label || 'request', textStatus || '', err || '');
				dfd.resolve(defaultVal);
			});
			return dfd.promise();
		}
		function asArray(v, fallback) {
			if (Array.isArray(v)) {
				if (v.length === 1 && Array.isArray(v[0])) {return v[0];}
				return v;
			}
			return (fallback || []);
		}
		function asObject(v, fallback) {
			if (v && typeof v === 'object' && !Array.isArray(v)) {return v;}
			return (fallback || {});
		}
		function parseNum(v) {
			if (v == null) {return null;}
			if (typeof v === 'number') {return (isFinite(v) ? v : null);}
			if (typeof v === 'string') {
				var n = Number(v.replace(',', '.').trim());
				return (isFinite(n) ? n : null);
			}
			return null;
		}
		var model = {
			element: null,
			template: 'templates/home.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: asObject((props && props.context && props.context.Model && props.context.Model.Main) || {}, {}),
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null,
				venueMunicipalAreasData: null,
				skyConditions: null,
				municipalByDay: null,
				latestUpdateISO: null
			}
		};
		var langparam = (lang === 'lld' ? 'lld' : lang);
		var base = (WebBaseAprovLV.config.azureStorageUrl[lang] || '');
		var cb = Date.now();
		var timeLayoutCandidates = ['144000000'];
		function fetchFirstAvailableTL() {
			var dfd = $.Deferred();
			var i = 0;
			function next() {
				if (i >= timeLayoutCandidates.length) {return dfd.resolve(null);}
				var id = timeLayoutCandidates[i++];
				var url = base + 'forecast-data/website/southtyrol/' + langparam + '_' + id + '.json'
                + (base.indexOf('?') === -1 ? ('?cb=' + cb) : ('&cb=' + cb));
				safeJSON(fetchFresh(url), null, 'tl:' + id)
				.done(function(resp) {
					if (resp) {
						var data = Array.isArray(resp) ? resp[0] : resp;
						if (data && data.data && Array.isArray(data.data.bulletins)) {
							return dfd.resolve({ id: id, data: data });
						}
					}
					next();
				});
			}
			next();
			return dfd.promise();
		}
		var homeReq = safeJSON(Utils.getKKData('?system.type=homepage&depth=3'), {}, 'kk homepage');
		var tplMain = safeJSON(ejs.preloadTemplate(model.template), null, 'tpl home');
		$.when(homeReq, tplMain).then(function(homeXhr) {
			var homeRaw = asObject(Array.isArray(homeXhr) ? homeXhr[0] : homeXhr, {});
			var vmArr = (Utils.getKKViewModel ? Utils.getKKViewModel(homeRaw) : [homeRaw]);
			var homeVM = asObject(vmArr && vmArr[0], {});
			model.data.pageRaw = homeRaw;
			model.data.pageContent = homeVM;
			model.data.home = homeVM;
			model.data.navRaw = {};
			model.data.nav = {};
			var municipalitiesReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/municipalities.json'), [], 'municipalities');
			var skyReq = safeJSON(fetchAsync(base + 'forecast-data/website/static-data/sky_conditions.json'), [], 'sky');
			var tlReq = fetchFirstAvailableTL();
			return $.when(municipalitiesReq, skyReq, tlReq);
		})
		.then(function(muniX, skyX, tlHit) {
			var municipalitiesRaw = asArray(muniX, []);
			var skyRaw = asArray(skyX, []);
			var municipalities = (Utils.localizeMunicipalRecords && Utils.localizeMunicipalRecords(municipalitiesRaw, lang)) || municipalitiesRaw;
			var pubs = [];
			if (tlHit && tlHit.data && tlHit.data.data && Array.isArray(tlHit.data.data.bulletins)) {
				pubs = [tlHit.data];
			}
			var municipalByDay = {};
			var latestUpdateISO = null;
			(pubs || [])
			.map(function(r) { return Array.isArray(r) ? r[0] : r; })
			.filter(function(r) { return r && r.data && Array.isArray(r.data.bulletins); })
			.forEach(function(pub) {
				var lu = pub && pub.meta && (pub.meta.last_update || pub.meta.date) || null;
				if (lu && (!latestUpdateISO || new Date(lu) > new Date(latestUpdateISO))) {
					latestUpdateISO = lu;
				}
				(pub.data.bulletins || []).forEach(function(b) {
					var iso = (b && b.period && b.period.start
						? Utils.localIsoDayFromUTC(b.period.start)
						: '');
					if (!iso) {return;}
					if (!municipalByDay[iso]) {
						municipalByDay[iso] = { summary: null, municipalities: [], meta: {} };
					}
					if (!municipalByDay[iso].meta || !municipalByDay[iso].meta.last_update) {
						municipalByDay[iso].meta = { last_update: lu || null };
					}
					if (!municipalByDay[iso].summary) {
						var T = b.temperatures || b.temperature || {};
						var Tmin = T && T.min ? T.min : null;
						var Tmax = T && T.max ? T.max : null;
						municipalByDay[iso].summary = {
							id_time_layout: b.id_time_layout,
							title: b.title || '',
							conditions: b.conditions || '',
							weather: b.weather || '',
							temperatureText: b.temperature || '',
							reliability: b.reliability,
							skyKey: String(b.skyCondition || '').toUpperCase(),
							tminLow: parseNum(Tmin && Tmin.low),
							tminHigh: parseNum(Tmin && Tmin.high),
							tmaxLow: parseNum(Tmax && Tmax.low),
							tmaxHigh: parseNum(Tmax && Tmax.high)
						};
					}
					var metrics = Array.isArray(b.municipalityMetrics) ? b.municipalityMetrics : [];
					for (var i = 0; i < metrics.length; i++) {
						var m = metrics[i];
						if (!m || m.venueId == null) {continue;}
						municipalByDay[iso].municipalities.push({
							venueId: String(m.venueId),
							sky_condition: m.sky_condition || null,
							temperature_minimum: parseNum(m.temperature_minimum),
							temperature_maximum: parseNum(m.temperature_maximum),
							rain_fall: parseNum(m.rain_fall),
							rain_probability: parseNum(m.rain_probability),
							sunshine_duration: parseNum(m.sunshine_duration),
							wind_speed: parseNum(m.wind_speed),
							wind_gust: parseNum(m.wind_gust),
							wind_direction: (m.wind_direction == null ? null : m.wind_direction),
							snow_level: parseNum(m.snow_level),
							fresh_snow: parseNum(m.fresh_snow),
							freezing_level: parseNum(m.freezing_level)
						});
					}
				});
			});
			model.element = $('#content');
			if (!model.element.length) {
				console.warn('[home] #content not found – creating fallback container');
				model.element = $('<div id="content"/>').appendTo('body');
			}
			model.data = $.extend(model.data, {
				venueMunicipalAreasData: municipalities,
				skyConditions: skyRaw || [],
				latestUpdateISO: latestUpdateISO,
				municipalByDay: municipalByDay
			});
			return Utils.transitionTo(model);
		})
		.then(function(ejsmodel) {
			var t1 = (window.performance && performance.now && performance.now()) || Date.now();
			console.info('[home] load+render took', Math.round(t1 - t0), 'ms');
			dfdRoot.resolve(ejsmodel);
		})
		.fail(function(err) {
			console.warn('[home] falling back to minimal render:', err);
			model.element = $('#content');
			if (!model.element.length) {model.element = $('<div id="content"/>').appendTo('body');}
			model.data.pageContent = model.data.pageContent || {};
			model.data.nav = model.data.nav || {};
			model.data.venueMunicipalAreasData = model.data.venueMunicipalAreasData || [];
			model.data.skyConditions = model.data.skyConditions || [];
			model.data.municipalByDay = model.data.municipalByDay || {};
			$.when(Utils.transitionTo(model))
			.done(function(ejsmodel) { dfdRoot.resolve(ejsmodel); })
			.fail(function(e) { dfdRoot.reject(e); });
		});
		return dfdRoot.promise();
	};
})();
